/**
 * Thin facade entry — the ONLY module in the stable, un-hashed `assets/app.js`
 * chunk (see entryFileNames in vite.config.ts). It exports nothing, so no lazy
 * chunk can ever emit `from "./app.js"` and double-instantiate the app: the
 * HTML loads `/assets/app.js?dt=<tag>` while chunk imports resolve to the bare
 * URL — two URLs = two module instances = duplicate React contexts (the
 * "useTheme must be used within a ThemeProvider" workspace crash).
 * All real code lives in the hashed chunk this import pulls in.
 *
 * The chunk-reload handler is registered here — statically, so it lives in this
 * un-hashed entry — before the app's first lazy import, so it can catch a
 * preload failure of any chunk (main's included).
 */
import { registerChunkReloadOnPreloadError } from './modules/chunkReload'

registerChunkReloadOnPreloadError()

void import('./main')
